import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Angular Material
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ShowForSignedDirective } from './auth/directives/show-for-signed.directive';
import { ShowForRolesDirective } from './auth/directives/show-for-roles.directive';
import { PipesModule } from './pipes/pipes.module';
import { MatSelectModule } from '@angular/material/select'; 
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { GridColumnsDirective } from './directives/grid-columns-directive/grid-columns.directive';
import { InputEditableComponent } from './components/shared/input-editable/input-editable.component';
import { MatBadgeModule } from '@angular/material/badge';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { FormErrorComponent } from './components/shared/form-error/form-error.component';
import { MatCheckboxModule } from '@angular/material/checkbox'; 
import { MatGridListModule } from '@angular/material/grid-list';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSlideToggleModule } from '@angular/material/slide-toggle'; 
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatRadioModule } from '@angular/material/radio';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    ShowForRolesDirective,
    ShowForSignedDirective,
    GridColumnsDirective,
    InputEditableComponent,
    FormErrorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    
    // Material
    MatInputModule,
    MatPaginatorModule,
    MatMenuModule,
    MatButtonModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatSelectModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatTableModule,
    MatSnackBarModule,
    MatDividerModule,
    MatCardModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatBadgeModule,
    MatCheckboxModule,
    MatGridListModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatRadioModule,

    PipesModule,
    NgxJsonViewerModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    
    // Material
    MatInputModule,
    MatPaginatorModule,
    MatMenuModule,
    MatButtonModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatSelectModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatTableModule,
    MatSnackBarModule,
    MatDividerModule,
    MatCardModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatBadgeModule,
    MatCheckboxModule,
    MatGridListModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatRadioModule,
    
    PipesModule,
    NgxJsonViewerModule,
    ShowForRolesDirective,
    ShowForSignedDirective,
    GridColumnsDirective,
    InputEditableComponent,
    FormErrorComponent
  ]
})
export class SharedModule {}
